import React, { Fragment } from 'react'
import config from '../config'
import { __ } from '../services/translate'

export const paginate = (pagination) => {

  // if there's less results than required for page
  if (pagination.total <= config.pagination.perPage) {
    return []
  }

  const pages = []

  if ((pagination.page - 1) * config.pagination.perPage > 0) {
    pages.push({
      name: <Fragment><i className="fa fa-caret-left"></i>&nbsp;{__('Novější')}</Fragment>,
      page: pagination.page - 1
    })
  }

  if (pagination.page * config.pagination.perPage < pagination.total) {
    pages.push({
      name: <Fragment>{__('Starší')}&nbsp;<i className="fa fa-caret-right"></i></Fragment>,
      page: pagination.page + 1
    })
  }

  return pages
}